<app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'">
  <app-pan-card [header]="'Queued Assignments History'" subheader="Historical Review Injections">
    @if (isLoadingHistory()) {
      <div class="flex justify-center py-4">
        <app-pan-spinner></app-pan-spinner>
      </div>
    }
    <ag-grid-angular [columnDefs]="historyTableColumns" [gridOptions]="historyTableOptions"></ag-grid-angular>
  </app-pan-card>
</app-pan-card>
